<template>
  <div class="page">
    <my-header :breadcrumb="breadcrumb"></my-header>
    <div class="content">
      <div class="content-wrap">
        <!--搜索-->
        <el-button type="primary" @click="clickAdd">添加分类</el-button>
        <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible">
          <el-form :model="form">
            <el-form-item label="分类名称" :label-width="formLabelWidth">
              <el-input v-model="form.cate_name"></el-input>
            </el-form-item>
            <el-form-item label="上级分类" :label-width="formLabelWidth">
              <el-select v-model="form.parentName" placeholder="请选择" @change="changeParent">
                <el-option
                  v-for="item in parentList"
                  :key="item.cate_id"
                  :label="item.cate_name"
                  :value="item.cate_id">
                </el-option>
              </el-select>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="clickConfirm">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 工具栏（列表名称、列表显示项设置） -->
        <!--列表内容-->

        <el-table
          :data="tableData"
          style="width: 100%;margin:10px 0 0 0;"
          row-key="cate_id"
          default-expand-all
          :tree-props="{children: 'children', hasChildren: 'hasChildren'}"
          :default-sort="{prop: 'nav_id', order: 'ascending'}"
        >

          <el-table-column
            prop="cate_name"
            label="分类名称"
            sortable
            width="380">
          </el-table-column>

          <el-table-column
            prop="sort_order"
            label="排序">
          </el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button
                size="mini"
                @click="handleEdit(scope.$index, scope.row)">编辑
              </el-button>
              <el-button
                size="mini"
                type="danger"
                @click="handleDelete(scope.$index, scope.row)">删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="totalCount" :page-size="10" class="page-wrap">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
  import MyHeader from "../header";
  import Cookies from "js-cookie"
  export default {
    name: "CategoryList",
    components: {
      MyHeader
    },
    data() {
      return {
        form: {
          parentName:'',
          typeName:'',
          moduleName:''
        },
        formLabelWidth:'120px',
        tableData: [],
        totalCount: 0,
        pageCount: 1,
        breadcrumb: [
          {
            name: '文章管理'
          },
          {
            name: '文章分类'
          }
        ],
        dialogFormVisible:false,
        arrType:[
          {label:'内部模块',value:1},
          {label:'外部链接',value:2}
        ],
        arrModule:[
          {label:'文章模块',value:1}
        ],
        showModule:false,
        showLink:false,
        dialogTitle:'添加分类',
        categoryList:[],
        parentList:[]
      }
    },
    created(){
      this.form.nav_id = this.$route.query.id;
      this.$http.get(this.apiUrl+'/v1/acategory/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
        this.tableData = data.result;
      })
    },
    methods:{
      clickAdd(){
        this.dialogFormVisible = true;
        this.$http.get('/v1/acategory/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
          this.parentList = data.result;
        })
      },
      clickConfirm(){
        this.form.site_id = Cookies.get('siteId');
        this.$http.post('/v1/acategory/save',this.form).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.dialogFormVisible = false;
            this.$http.get(this.apiUrl+'/v1/acategory/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
              this.tableData = data.result;
            })
          }else{
            this.$message.error(data.msg);
          }
        })
      },
      handleEdit(index,row){
        var _this = this;
        this.dialogFormVisible = true;
        this.dialogTitle = '修改文章分类';
        this.$http.get('/v1/acategory/view?id='+row.cate_id).then(({data})=>{
          _this.form = data.result;
          this.parentList  = this.tableData;
          console.log(this.parentList);
          this.parentList.forEach(function (item){
            console.log(item);
            if (item.cate_id == row.parent_id){
              //_this.form.parentName = item.cate_name;
              _this.$set(_this.form,'parentName',item.cate_name);
            }
          })
          console.log(_this.form);
        })
      },
      handleDelete(index,row){
        this.$http.delete('/v1/acategory/delete?id='+row.cate_id).then(({data})=>{
          if (data.errcode == 0){
            this.$message.success(data.msg);
            this.$http.get('/v1/acategory/list',{params:{siteId:Cookies.get('siteId')}}).then(({data})=>{
              this.tableData = data.result;
            })
          }else{
            this.$message.error(data.msg)
          }
        })
      },
      changeType(val){
        this.form.type = val;
        if (val == 1){
          this.showModule = true;
          this.showLink = false;

        }else {
          this.showLink = true;
          this.showModule = false;
          this.form.module_id = 0;
        }
      },
      changeModule(val){
        this.form.module_id = val;
        if (val == 1){
          this.$http.get('/v1/acategory/list?siteId='+Cookies.get('siteId')).then(({data}) => {
            this.categoryList = data.result;
          })
        }

      },
      changeCate(val){
        var _this = this;
        this.form.category_id = val;
        if (!this.form.nav_id){
          this.categoryList.forEach(function (item) {
            if(item.cate_id == val){
              _this.form.title =  item.cate_name;
            }
          })
        }

      },
      changeParent(val){
        var _this = this;
        this.form.parent_id  = val;
        this.tableData.forEach(function (item) {
          if (item.cate_id == val){
            _this.form.parentName = item.cate_name;
          }
        })
      }
    }
  }
</script>

<style scoped>
  .page-wrap{
    float: right;
    margin:30px 0 0 0;
  }
</style>
